import './App.css';
import Navbar from './components/navbar/navbar';
import {Route, Routes, BrowserRouter as Router} from 'react-router-dom';

import { initializeApp } from 'firebase/app';
import About from './pages/about/about';
import Cohort from './pages/cohort/cohort';
import Application from './pages/application/application';
import Members from './pages/members/members';
import Agreement from './pages/agreement/agreement';

function App() {
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const firebaseConfig = {
    apiKey: "AIzaSyDcrzHOqnrAyk0lPxvbLCXRRDxiGcndJkA",
    authDomain: "ricecake-c2bdf.firebaseapp.com",
    projectId: "ricecake-c2bdf",
    storageBucket: "ricecake-c2bdf.firebasestorage.app",
    messagingSenderId: "723124683276",
    appId: "1:723124683276:web:97e9f952cada0f3bb66429",
    measurementId: "G-E0WHLY9CBJ"
  };
  initializeApp(firebaseConfig);

  return (
    <div className='App'>
      <Router>

        <link href="https://fonts.googleapis.com/css2?family=Taviraj&family=Questrial&display=swap" rel="stylesheet"/>
        <Navbar/>

        <Routes>
          <Route path='/' element={< About />}></Route>
          <Route path='/about' element={< About />}></Route>
          <Route path='/cohort' element={< Cohort />}></Route>
          <Route path='/apply' element={< Application />}></Route>
          <Route path='/members' element={< Members />}></Route>
          <Route path='/agreement' element={< Agreement />}></Route>
        </Routes>
      </Router>

    </div>
  );
}

export default App;
